import { useState } from 'react';
import PageContainerBlank from '../../components/PageContainer/PageContainerBlank.js';
import PageEndBlank from '../../components/PageContainer/PageEndBlank.js';
import FlexPair from '../../components/FlexPair/FlexPair.js';
import PdfPreviewer from '../../components/PdfPreviewer/PdfPreviewer';
import { getBulletinPdfBase64 } from "../../utils/CloudFunctions.js";
import Button from '../../components/Button/Button';
import FlexColumn from '../../components/FlexColumn/FlexColumn';
import { BULLETIN_GAP, MOBILE_BULLETIN_GAP } from '../../utils/Constants.js';

const BulletinViewer = () => {
	const [stJosephPDF, setStJosephPDF] = useState({});
	const [abvmPDF, setAbvmPDF] = useState({});
	const [conewagoPDF, setConewagoPDF] = useState({});
	const [stVincentPDF, setStVincentPDF] = useState({});

	const [buttonClicked, setButtonClicked] = useState(false);
	
	const [stJosephLoading, setStJosephLoading] = useState(null);
	const [abvmLoading, setAbvmLoading] = useState(null);
	const [conewagoLoading, setConewagoLoading] = useState(null);
	const [stVincentLoading, setStVincentLoading] = useState(null);

	const doRequest = () => {
		setButtonClicked(true);
		setStJosephLoading(true);
		setAbvmLoading(true);
		setConewagoLoading(true);
		setStVincentLoading(true);

		const fetchStJoseph = async () => {
			try {
				const data = await getBulletinPdfBase64("st_joseph");
				setStJosephPDF(data);
			} catch (err) {
				console.error('Error fetching bulletins:', err);
			} finally {
				setStJosephLoading(false);
			}
		};
		const fetchAbvm = async () => {
			try {
				const data = await getBulletinPdfBase64("abvm");
				setAbvmPDF(data);
			} catch (err) {
				console.error('Error fetching bulletins:', err);
			} finally {
				setAbvmLoading(false);
			}
		};
		const fetchConewago = async () => {
			try {
				const data = await getBulletinPdfBase64("conewago");
				setConewagoPDF(data);
			} catch (err) {
				console.error('Error fetching bulletins:', err);
			} finally {
				setConewagoLoading(false);
			}
		};
		const fetchStVincent = async () => {
			try {
				const data = await getBulletinPdfBase64("st_vincent");
				setStVincentPDF(data);
			} catch (err) {
				console.error('Error fetching bulletins:', err);
			} finally {
				setStVincentLoading(false);
			}
		};

		fetchStJoseph();
		fetchAbvm();
		fetchConewago();
		fetchStVincent();
	};

	const stJosephContent = (
		<PdfPreviewer base64Data={stJosephPDF?.base64Data} loading={stJosephLoading} parishName="St. Joseph" bulletinsLink="https://parishesonline.com/organization/st-joseph-catholic-church-17331" />
	);
	const abvmContent = (
		<PdfPreviewer base64Data={abvmPDF?.base64Data} loading={abvmLoading} parishName="Annunciation" bulletinsLink="https://discovermass.com/church/annunciation-of-the-blessed-virgin-mary-parish-mc-sherrystown-pa/#bulletins" />
	);
	const conewagoContent = (
		<PdfPreviewer base64Data={conewagoPDF?.base64Data} loading={conewagoLoading} parishName="Sacred Heart" bulletinsLink="https://www.sacredheartbasilica.com/bulletins" />
	);
	const stVincentContent = (
		<PdfPreviewer base64Data={stVincentPDF?.base64Data} loading={stVincentLoading} parishName="St. Vincent" bulletinsLink="https://www.svparish.org/events/weekly-bulletin/" />
	);

	return (
		<div>
			<PageContainerBlank />

			<h1>Bulletin Viewer</h1>
			<FlexColumn>
				<p className='centered'>This tool gathers together all the church bulletins of the Hanover-area parishes.</p>
				{buttonClicked === false && (<Button onClick={doRequest}>Get Bulletins!</Button>)}
			</FlexColumn>
			<br />
			<br />

			{buttonClicked === true && (
				<FlexColumn pcGap={BULLETIN_GAP} mobileGap={MOBILE_BULLETIN_GAP}>
					<FlexPair leftContent={stJosephContent} rightContent={abvmContent} mobileGap={MOBILE_BULLETIN_GAP} />
					<FlexPair leftContent={conewagoContent} rightContent={stVincentContent} mobileGap={MOBILE_BULLETIN_GAP} />
				</FlexColumn>
			)}

			<br />
			<PageEndBlank />
		</div>
	);
};

export default BulletinViewer;